import React from "react";
import { Box, LinearProgress, Stack } from "@mui/material";

const JointChartDataSkeletonHelper = () => {
    return (
        <Stack alignItems="center" mt={5} sx={{ width: "100%" }}>
            <p>Joining data</p>
            <Box sx={{ width: "50%" }}>
                <LinearProgress />
            </Box>
        </Stack>
    );
};

export default JointChartDataSkeletonHelper;
